<template>
  <div class="container section-holder" id="library-cards">
    <div v-if ="$store.getters.getrecommendedItems !== undefined && $store.getters.getrecommendedItems !== null && $store.getters.getrecommendedItems.length>0" class="pb-2 row justify-content-end">
      <h6 class="main-title col-12 text-left">{{$t('recommendation.labels.you_may_like')}}</h6>
    </div>
    <div v-if ="$store.getters.getrecommendedItems !== undefined && $store.getters.getrecommendedItems !== null && $store.getters.getrecommendedItems.length>0" class="swiper-holder">
        <swiper :options="swiperOption2" class="">
          <!-- <swiper-slide v-for="(item,i) in $store.getters.getrecommendedItems" :key="i"> -->
          <swiper-slide v-for="(item,i) in $store.getters.getrecommendedItems" :key="i" v-if ="!$store.getters.getItemPurchasedStatus(item.contentId)">
              <div class="card-design" > 
                <div class="card-design__img" v-lazy-container="{ selector: 'img' }" v-if="item.thumbnail.length != 0">
                  <img :data-src="makePath(item.thumbnail)" alt="">
                </div>
                <div class="card-design__img" v-lazy-container="{ selector: 'img' }" v-else>
                  <img data-src="../../../static/assets/images/defaultLO.jpg" alt="">
                </div>
                <div class="card-design__data">
                  <div class="lo-label" v-if="item.type == 'LO'">{{$t('libraryCards.labels.lo_label')}}</div>
                  <!-- text based info -->
                  <h3 class="card-design__data-heading text-truncate" v-b-tooltip.hover :title="item.title" v-if="item.type == 'LO'">{{item.title}}</h3>
                  <router-link tag="h3" v-b-tooltip.hover :title="item.title"  class="card-design__data-heading text-truncate" v-if="item.type == 'CO'" :to="{ name: 'coursePage', params: { contentId: item.contentId }}">{{item.title}}</router-link>

                  <!-- <p class="card-design__data-sub">{{item.description}}</p> -->
                  <p class="card-design__data-cost">{{item.price}} {{item.price > 1 ? 'Points' : 'Point '}}</p>
                   <div class="ratingText">{{$t('common.labels.OVERALL_RATING')}}</div>
                  
                  <!-- rating section -->
                  <div v-if="parseInt(item.rating) == 0">
                    <star-rating :rating="parseInt(item.rating)" :read-only=true v-bind:increment="0.5" v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
                  </star-rating>  
                  </div>
                  <div v-else>
                    <star-rating :rating="parseInt(item.rating.toFixed(1))" :read-only=true v-bind:increment="0.5" v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
                  </star-rating>
                  </div>

                  <!-- share widgets -->
                  <div class="ratingText">Share On </div>
                  <social-sharing :url="'www.livedemy.mkcl.org/' + item.title"
                    :title="item.title"
                    :description="item.title"                      
                    inline-template>
                    <div class="social-links">
                      <network network="email">
                          <i class="mdi mdi-email"></i> 
                      </network>
                      <network network="facebook">
                        <i class="mdi mdi-facebook"></i> 
                      </network>    
                      <network network="twitter">
                      <i class="mdi mdi-twitter"></i> 
                      </network>  
                      <network network="linkedin">
                        <i class="mdi mdi-linkedin"></i> 
                      </network>  
                        <network network="skype">
                        <i class="mdi mdi-skype"></i> 
                      </network>  
                        <!-- <network network="whatsapp">
                        <i class="mdi mdi-whatsapp"></i> 
                      </network>   -->
                    </div>
                  </social-sharing>

                  <!-- action if user is logged in -->
                  <div class="row mt-3" v-if="isLoggedIn">

                    <!-- cart / contentViewer  sect -->
                    <!-- if item subscription had not expired -->
                    <div class="col" v-if ="$store.getters.getItemSubscriptionStatus({'id': item.contentId, 'type': item.type}) != undefined && $store.getters.getItemSubscriptionStatus({'id': item.contentId, 'type': item.type}) != null && $store.getters.getItemSubscriptionStatus({'id': item.contentId, 'type': item.type})">
                      <button  @click="playLO(item)" class="btn btn-green-o">{{$t('common.labels.PLAY_NOW')}}</button>
                    </div>
                    <!-- if item subscription had expired -->
                    <div class="col" v-else>
                     <button v-if="$store.getters.itemPresentInCartStatus(item.contentId)!= undefined && $store.getters.itemPresentInCartStatus(item.contentId)!= null && $store.getters.itemPresentInCartStatus(item.contentId)" class="btn btn-green-alt">{{$t('common.labels.ADDED')}}</button> 
                     <button v-else @click="addToCart(item.contentId)" class="btn btn-green-o">{{$t('common.labels.ADD_TO_CART')}}</button>
                    </div>


                    <!-- wishList section -->
                    <!-- if user had not purchased item -->
                    <div class="col-auto heart-holder"  v-if="$store.getters.getItemPurchasedStatus(item.contentId) != undefined && $store.getters.getItemPurchasedStatus(item.contentId) != null && !$store.getters.getItemPurchasedStatus(item.contentId)">
                      <!-- if item present in wishList -->
                      <div v-if="$store.getters.itemPresentInWishListStatus(item.contentId) != undefined && $store.getters.itemPresentInWishListStatus(item.contentId) != null && $store.getters.itemPresentInWishListStatus(item.contentId)">
                        <div class="heart" v-show="$store.getters.itemPresentInCartStatus(item.contentId) != undefined && $store.getters.itemPresentInCartStatus(item.contentId)!= null && !$store.getters.itemPresentInCartStatus(item.contentId)" v-on:click="removeFromWishList(item.contentId)" title="Add to Wishlist" v-bind:class="{ 'is-active' : true}"></div>
                      </div>
                      <!-- if item is present in cart -->
                      <div v-else-if="$store.getters.itemPresentInCartStatus(item.contentId) != undefined && $store.getters.itemPresentInCartStatus(item.contentId) != null &&  $store.getters.itemPresentInCartStatus(item.contentId)"></div>
                      <!-- if item not in cart and in wishList -->
                      <div v-else>
                        <div class="heart" v-on:click="addToWishList(item.contentId)" title="Add to Wishlist" v-bind:class="{ 'is-active' : false}"></div>
                      </div>
                    </div>
                    
                  </div>

                  <!-- action to perform when user is not logged in -->
                  <div class="row mt-3" v-else>
                    <div class="col">
                      <button @click="goToLogin()" class='btn btn-green-o'>{{$t('common.labels.ADD_TO_CART')}}</button>
                    </div>
                    <div class="col-auto heart-holder">
                      <div class="heart" v-on:click="goToLogin()" title="Add to Wishlist" v-bind:class="{ 'is-active' : false}"></div>
                    </div>
                  </div>
                </div>
              </div>
              
          </swiper-slide>
               <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
    </div>


  </div>

</template>
<script>
import axios from 'axios'
import {CDP_CDN_THUMBNAIL_URL} from '@/components/common/constants.js'
import StarRating from 'vue-star-rating'
export default {
  name: 'recommendation',
  components: {
    StarRating
  },
  data () {
    return {
      isValidUser: false,
      isActive: false,
      notNextTick: true,
      obj: {},
      items: [],
      coList: [],
      loList: [],
      add: 'Add to Cart',
      itemDescription: 'Coarse is to help you with some basics of HTML',
      itemName: 'HTML5 Demo',
      swiperOption2: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 'auto',
        // slidesPerGroup: 4,
        spaceBetween: 24,
        paginationClickable: true,
        loop: false
      },
      selected: [], // Must be an array reference!
      options: [
        { text: 'Playlist 1', value: 'Playlist 1' },
        { text: 'Playlist 2', value: 'Playlist 2' },
        { text: 'Playlist 3', value: 'Playlist 3' },
        { text: 'Playlist 4', value: 'Playlist 4' },
        { text: 'Playlist 5', value: 'Playlist 5' },
        { text: 'Playlist 6', value: 'Playlist 6' }
      ]
    }
  },
  methods: {
    goToLogin () {
      // window.MKCLAPI.login()
      this.$toasted.success(this.$t('common.labels.CART_WISHLIST_WITHOUT_LOGIN'))
      return
    },
    makePath (path) {
      return CDP_CDN_THUMBNAIL_URL + '/' + path
      // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
    },
    addToWishList (itemId) {
      if (this.isLoggedIn) {
        // if user is loggedIn then call to insert api
        this.$store.dispatch('insertWishListInDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(
          response => {
            this.$toasted.success(this.$t('wishlist.alerts.AddedToWishList'))
          },
          error => {
            console.error('error in adding item to wishList', error)
          }
        )
      } else {
        window.MKCLAPI.login()
      }
    },
    removeFromWishList (itemId) {
      this.$swal({
        title: this.$t('wishlist.alerts.RemoveItemConfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          this.$store.dispatch('removeWishListFromDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(
            response => {
              this.$toasted.success(this.$t('wishlist.alerts.RemoveItem'))
            },
            error => {
              console.log('error in removing item from db', error)
            }
          )
        }
      })
    },
    addToCart (id) {
      if (this.isLoggedIn) {
        // if user is loggedIn then call to insert api
        this.$store.dispatch('addCartData', { itemId: id, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(
          response => {
            this.$toasted.success(this.$t('common.alerts.CART_ADDED_SUCCESS'))
          },
          error => {
            console.log('error in adding item to cart', error)
          }
        )
      } else {
        window.MKCLAPI.login()
      }
    },
    playLO (val) {
      var LOObj = []
      return new Promise((resolve) => {
        axios.post('r/learningobject/getlodatabyitemid', {'itemId': val.contentId}).then(Response => {
          if (Response.status === 200) {
            LOObj = Response.data
            this.$store.dispatch('setCurrentContentViewerPlaylist', LOObj).then(response => {
              resolve()
              this.$store.dispatch('setIsPlaylist', false).then(response => {
                this.$router.push('/frames')
              })
            })
          }
        }).catch(err => {
          console.log(err)
        })
      })
    }
  },
  beforeDestroy () {
    // clear store data
    if (this.$store.getters.getIsLoggedIn) {
      this.$store.dispatch('clearMostWatchedLosFromStore').then(response => {
      }, error => {
        console.log('error in clearMostWatchedLosFromStore', error)
      })
    }
  },
  mounted () {
    if (this.$store.getters.getIsLoggedIn && this.$store.getters.getProfileDetails.profileId !== undefined && this.$store.getters.getProfileDetails.profileId !== null) {
      // call api to fetch recommeded items from Db to be displayed
      this.$store.dispatch('fetchRecommendedItemsFromDB', {'profileId': this.$store.getters.getProfileDetails.profileId}).then(
        response => {},
        error => {
          console.log('error in fetchMostWatchedLosFromDb', error)
        }
      )
    } /* else {
      if (this.$store.getters.getrecommendedItems.length === 0) {
        this.$store.dispatch('fetchMostWatchedLosFromDb').then(
          response => {},
          error => {
            console.log('error in fetchMostWatchedLosFromDb', error)
          }
        )
      }
    } */
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.getIsLoggedIn
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/home/recommendation.vue?b2cf91b0